import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { SegmentControl } from "../segment-control";
export const PopoverPanel = ({ id, testId, selectedTab, children, }) => {
    const childrenArray = React.Children.toArray(children);
    let [layerSelector, presets, mapSettings] = childrenArray;
    let presetsAbsent = false;
    if (mapSettings === undefined || mapSettings === null) {
        // presets not yet provided, and map settings is actually at that index
        presetsAbsent = true;
        mapSettings = presets;
        presets = undefined;
    }
    const [activeIndex, setActiveIndex] = useState(presetsAbsent
        ? selectedTab === "map-settings"
            ? 1
            : 0
        : selectedTab === "map-settings"
            ? 2
            : selectedTab === "presets"
                ? 1
                : 0);
    const handleSelect = (index) => {
        setActiveIndex(index);
    };
    const renderContent = () => {
        switch (activeIndex) {
            case 2:
                return _jsx("div", { children: mapSettings });
            case 1:
                return presetsAbsent ? _jsx("div", { children: mapSettings }) : _jsx("div", { children: presets });
            case 0:
            default:
                return _jsx("div", { children: layerSelector });
        }
    };
    return (_jsxs("div", { id: id, "data-test-id": testId, "data-eco-component": "eco-timeline-popover-panel", children: [_jsx("div", { className: "p-2", children: _jsx(SegmentControl, { selected: activeIndex, onSelect: handleSelect, children: [
                        _jsx(SegmentControl.Button, { iconName: "layer-group", label: "Layers" }, "layers"),
                        ...(presets
                            ? [
                                _jsx(SegmentControl.Button, { iconName: "square-star", label: "Presets" }, "presets"),
                            ]
                            : []),
                        _jsx(SegmentControl.Button, { iconName: "gear", label: "Settings" }, "settings"),
                    ] }) }), renderContent()] }));
};
